import React, { Component } from 'react';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { API_URL } from '../../config';
import { toggleStatsModal, } from '../Stats/actions';
import StatsContainer from '../Stats/StatsContainer';
import { APP_TITLE, } from '../../config';

import { StyledHeader } from './styles/StyledHeader';


class Header extends Component {
  render() {
    const {
      logoName, office,
      toggleStatsModal,
    } = this.props;
    const haveLogo = logoName !== '';
    const logoSrc = API_URL + '/files/' + logoName;

    return (
      <StyledHeader>

        <StatsContainer/>

        {(haveLogo && APP_TITLE !== '') && (
          <div className="header-panel--title-small header-panel--title">
            { APP_TITLE }
          </div>
        )}

        <div className="header-row">
          <div className="header-column header-logo disable-select">
            <Link 
              className="header-text"
              to="/"
            >
              { haveLogo &&
                <img className="header-logo-img" src={logoSrc} alt="logo" />
              }
              { !haveLogo &&
                <span>
                  Rezervační systém
                </span>
              }
             
            </Link>
          </div>
          <div className="header-column header-panel">
            {(haveLogo && APP_TITLE !== '') && (
              <span className="header-panel--title-wide header-panel--title">
                { APP_TITLE }
              </span>
            )}
            <span className="header-panel--item disable-select"
              onClick={() => toggleStatsModal(office)}
            >
              <i className="fa fa-bar-chart" aria-hidden="true"></i> <span className="header-panel--item-text">Stav služeb</span>
            </span>
          </div>
        </div>

      </StyledHeader>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleStatsModal: bindActionCreators(toggleStatsModal, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js